import axios from "../api";
export async function getSbcSet(sbcSetId) {
    const response = await axios.get(`/sbc-sets/${sbcSetId}`);
    const sbcSet = {
        ...response.data,
        reward: response.data.rewards?.[0],
        img: response.data.imageURL,
        upVotes: response.data.upVotes ?? 0,
        downVotes: response.data.downVotes ?? 0,
    };
    return sbcSet;
}
//# sourceMappingURL=getSbcSet.js.map